import './form_ui.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';
import map from 'lodash/map';
import some from 'lodash/some';

import SiteViewerVersionComponentSelector from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';
import FormInput from './form_input.jsx';
import { ChevronRightIcon } from 'zoomforth_component_lib/external_modern_icons.jsx';
import {
  questionPropType,
  formValuePropType,
  formErrorPropType
} from './prop_types.js';

import {
  setTextLinksToDisplayExternalOpenMsg
} from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

class FormUi_ViewerVersion2 extends Component {
  
  constructor(props) {
    super(props);

    this.formRef = null;

    autobind(this);
  }

  handleFormRefReceived(ref) {
    this.formRef = ref;

    setTextLinksToDisplayExternalOpenMsg(this.formRef, '.form-wrapper a');
  }

  render() {
    const {
      questions,
      formValueByQuestionName,
      verticalAlign,
      horizontalAlign,
      headerHtml,
      formErrors,
      hasErrors,
      isSubmitted,
      thankYouMessage,
      uniqueFormString,
      onFormSubmit,
      onQuestionChange,
      onQuestionTouch
    } = this.props;

    const style = {};

    if (verticalAlign) {
      style['verticalAlign'] = verticalAlign;
    }
    if (horizontalAlign) {
      style['textAlign'] = horizontalAlign;
    }

    if (isSubmitted) {
      return (
        <span className="tile-text tile-form"> {/* this is unfortunately required for the form to display properly in the tile */}
          <div className="v2-tile-form">
            <div style={style}>
              <p className="form-thank-you-message">
                {thankYouMessage}
              </p>
            </div>
          </div>
        </span>
      );
    }

    return (
      <span
        style={style}
        className="tile-text tile-form"
        id={`tile-form-random_${uniqueFormString}`}
        ref={this.handleFormRefReceived}
      > {/* this is unfortunately required for the form to display properly in the tile */}
        <div>
          <div className="form-wrapper">
            <form onSubmit={onFormSubmit}>
              <div className="form-header">
                <div className="header-html" dangerouslySetInnerHTML={{ __html: headerHtml }} />
                <div id="optional-description">
                  "(optional)" questions are optional.
                </div>
              </div>
              {hasErrors &&
                <div className="form-errors">
                  <p>Please fill in all required fields:</p>
                  <ul>
                    {
                      map(formErrors, (formError) => (
                        <li key={formError.href}>
                          <a href={'#' + formError.href}>{formError.message}</a>
                        </li>
                      ))
                    }
                  </ul>
                </div>
              }
              <div className="form-inputs">
                {
                  map(questions, (question) => {
                    return <FormInput
                      key={question.name}
                      question={question}
                      formValue={formValueByQuestionName[question.name]}
                      uniqueFormString={uniqueFormString}
                      onQuestionChange={onQuestionChange}
                      onQuestionTouch={onQuestionTouch}
                    />;
                  })
                }
              </div>
              <div className="form-buttons">
                <button disabled={hasErrors} className="form-submit-button" type="submit">
                  <span className="form-submit-button-text">Submit</span>
                  <ChevronRightIcon className="form-submit-button-icon" />
                </button>
              </div>
            </form>
          </div>
        </div>
      </span>
    );
  }

}

FormUi_ViewerVersion2.propTypes = {
  questions: PropTypes.arrayOf(
    questionPropType.isRequired
  ).isRequired,
  formValueByQuestionName: PropTypes.objectOf(
    formValuePropType.isRequired
  ).isRequired,
  formErrors: PropTypes.arrayOf(
    formErrorPropType.isRequired
  ),
  hasErrors: PropTypes.bool.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  thankYouMessage: PropTypes.string.isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  onQuestionChange: PropTypes.func.isRequired,
  onQuestionTouch: PropTypes.func.isRequired,
  headerHtml: PropTypes.node.isRequired

  //verticalAlign, // not quite sure what this is yet
  //horizontalAlign, // not quite sure what this is yet
};

const FormUi_ViewerVersion1 = ({
  questions,
  formValueByQuestionName,
  verticalAlign,
  horizontalAlign,
  headerHtml,
  hasErrors,
  isSubmitted,
  thankYouMessage,

  onFormSubmit,
  onQuestionChange,
  onQuestionTouch,
}) => {
  const style = {};
  if (verticalAlign) {
    style['verticalAlign'] = verticalAlign;
  }
  if (horizontalAlign) {
    style['textAlign'] = horizontalAlign;
  }

  if (isSubmitted) {
    return (
      <div className="tile-text tile-form" style={style}>
        <div className="form-view">
          <p className="form-thank-you-message">
            {thankYouMessage}
          </p>
        </div>
      </div>
    );
  }

  // why is this a false const???
  const useAntiClickCover = false;

  return (
    <div className="tile-text tile-form" style={style}>
      <div className="form-view">
        {
          headerHtml && (
            <div className="form-header" dangerouslySetInnerHTML={{ __html: headerHtml }}></div>
          )
        }
        <form className="form-wrapper" onSubmit={onFormSubmit}>
          {
            some(questions, 'isRequired') &&
            <div className="form-field-container">
              <span className="form-field-required-indicator-text">* questions are required.</span>
            </div>
          }
          {
            map(questions, (question) => {
              return [(
                <FormInput
                  key={question.name}
                  question={question}
                  formValue={formValueByQuestionName[question.name]}
                  onQuestionChange={onQuestionChange}
                  onQuestionTouch={onQuestionTouch}
                />
              ), (
                <div key={questions.name + '-spacer'} className="form-spacer"></div>
              )];
            })
          }
          {hasErrors && <p className="form-field-error">Please fill in all the required questions</p>}
          <input disabled={hasErrors} className="button-style submit-form action-submit-form" type="submit" value="Submit" />
        </form>
        {
          useAntiClickCover ?
            <div className="form-anti-click-cover"></div>
            : null
        }
      </div>
    </div>
  );
};

FormUi_ViewerVersion1.propTypes = {
  questions: PropTypes.arrayOf(
    questionPropType.isRequired
  ).isRequired,
  formValueByQuestionName: PropTypes.objectOf(
    formValuePropType.isRequired
  ).isRequired,
  hasErrors: PropTypes.bool.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  thankYouMessage: PropTypes.string.isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  onQuestionChange: PropTypes.func.isRequired,
  onQuestionTouch: PropTypes.func.isRequired,
  headerHtml: PropTypes.node.isRequired
  //verticalAlign, // not quite sure what this is yet
  //horizontalAlign, // not quite sure what this is yet
};

const FormUi = (props) => (
  <SiteViewerVersionComponentSelector>
    <FormUi_ViewerVersion1 forSiteViewerVersion={1} {...props} />
    <FormUi_ViewerVersion2 forSiteViewerVersion={2} {...props} />
  </SiteViewerVersionComponentSelector>
);

export default FormUi;
